// vehicleWarrantyPeriodApi.js

import { rootApi } from '../rootApi';

export const vehicleWarrantyPeriodApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllVehicleWarrantyPeriod: builder.query({
            query: ({ pageNumber, pageSize, carItemCode, chassisNo }) => ({
                url: 'v1/vehicleadditionalwarrantyperiod/getlist',
                method: 'POST',
                body: {
                    carItemCode,
                    chassisNo,
                    pageNumber,
                    pageSize
                }
            }),
            providesTags: ['VehicleWarrantyPeriod']
        }),
        getVehicleWarrantyPeriodById: builder.query({
            query: (id) => ({
                url: `v1/vehicleadditionalwarrantyperiod/getbyid?id=${id}`,
                method: 'GET'
            }),
            providesTags: (result, error, id) => [{ type: 'VehicleWarrantyPeriod', id }]
        }),
        updateVehicleWarrantyPeriod: builder.mutation({
            query: (data) => ({
                url: 'v1/vehicleadditionalwarrantyperiod/update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, data) => [{ type: 'VehicleWarrantyPeriod', id: data.id }, 'VehicleWarrantyPeriod']
        }),
        uploadVehicleWarrantyPeriodDocument: builder.mutation({
            query: ({ vehicleAdditionalWarrantyPeriodId, file, description }) => {
                const formData = new FormData();
                formData.append('VehicleAdditionalWarrantyPeriodId', vehicleAdditionalWarrantyPeriodId);
                formData.append('File', file);
                formData.append('Description', description);
                return {
                    url: 'v1/vehicleadditionalwarrantyperiod/uploaddocument',
                    method: 'POST',
                    body: formData,
                    formData: true
                };
            },
            invalidatesTags: (result, error, { vehicleAdditionalWarrantyPeriodId }) => [{ type: 'VehicleWarrantyPeriodDocument', id: vehicleAdditionalWarrantyPeriodId }]
        }),
        getVehicleWarrantyPeriodDocumentsById: builder.query({
            query: (id) => ({
                url: `v1/vehicleadditionalwarrantyperiod/getdocumentsbyid?id=${id}`,
                method: 'GET'
            }),
            providesTags: (result, error, id) => [{ type: 'VehicleWarrantyPeriodDocument', id }]
        }),

        deleteDocumentVehicleWarrantyPeriod: builder.mutation({
            query: (data) => ({
                url: 'v1/vehicleadditionalwarrantyperiod/DeleteDocument',
                method: 'DELETE',
                body: data
            }),
            invalidatesTags: (result, error, { vehicleAdditionalWarrantyPeriodId }) => [{ type: 'VehicleWarrantyPeriodDocument', id: vehicleAdditionalWarrantyPeriodId }]
        })
    })
});

export const {
    useGetAllVehicleWarrantyPeriodQuery,
    useLazyGetVehicleWarrantyPeriodByIdQuery,
    useUpdateVehicleWarrantyPeriodMutation,
    useUploadVehicleWarrantyPeriodDocumentMutation,
    useLazyGetVehicleWarrantyPeriodDocumentsByIdQuery,
    useDeleteDocumentVehicleWarrantyPeriodMutation
} = vehicleWarrantyPeriodApi;
